export default "__VITE_PUBLIC_ASSET__421960c4__"